import { render, staticRenderFns } from "./shipmentOrderPage.vue?vue&type=template&id=1075a2ad&"
import script from "./shipmentOrderPage.vue?vue&type=script&lang=js&"
export * from "./shipmentOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports